import { render, staticRenderFns } from "./ActionItemWrapper.vue?vue&type=template&id=39d9d0a6&scoped=true&"
import script from "./ActionItemWrapper.vue?vue&type=script&lang=js&"
export * from "./ActionItemWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ActionItemWrapper.vue?vue&type=style&index=0&id=39d9d0a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d9d0a6",
  null
  
)

export default component.exports